import styled from 'styled-components'

import LocationEditFormUnstyled from 'Containers/Form/City/Locations/LocationEdit/unstyled'

export const LocationEditForm = styled(LocationEditFormUnstyled)`
  margin: 0 -15px;

  .row {
    margin: 0 0 30px 0;
  }

  .row:last-child {
    margin: 0;
  }
`
